import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import SVGIcon from '../helpers/icons'

function Select (props) {

  const manager = usePortManager()

  const toggleSelectClass = event => {
    const selectWrapper = event.target.parentNode
    selectWrapper.classList.toggle('select-wrap--open')
  }

  return (
    <aside>
      <div className={'select-wrap'} onClick={() => toggleSelectClass(event)}>
        <button
          className={'select'}
          onClick={() => manager.togglePortModal()}
        >{manager.currentPort.name}</button>
        <SVGIcon type={'arrow-up'} fill={'#C5C5C5'} className={'select-arrow'}/>
      </div>
    </aside>
  )
}

export default observer(Select)